<app-nabvar></app-nabvar>
<!-- Router outlet (solo si usas rutas) -->
<router-outlet></router-outlet>
<app-footer></app-footer>
